import Logo from './Logo.svg';

type ImageProps = React.JSX.IntrinsicElements['div'] & {
  width?: string;
  alt?: string;
}

export const OnDeckLogo = ({width = "155px", alt = "OnDeck", ...props}: ImageProps) => <div {...props}><img src={Logo} width={width} alt={alt} /></div>
export default OnDeckLogo;
